import '../fake-db';
import React, { useEffect, useState, useContext } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Router, Switch, Route } from 'react-router-dom';
import AppContext from './contexts/AppContext';
import history from 'history.js';
import routes from './RootRoutes';
import store from '../store';
import { GlobalCss, MatxSuspense, MatxTheme, MatxLayout } from 'components';
import sessionRoutes from './views/sessions/SessionRoutes';

import AuthGuard from './auth/AuthGuard';
import { AuthProvider } from 'app/contexts/FirebaseAuthContext';
import { SettingsProvider } from 'app/contexts/SettingsContext';
import ScrollToTop from 'components/common/ScrollToTop/ScrollToTop';

import { AppControlContextProvider } from './contexts/AppControlContext';
import { ShopContextProvider } from './contexts/ShopContext';
import { DeveloperUuidContextProvider } from './contexts/DeveloperUuidContext';
import { AppShopContextProvider } from './contexts/AppShopContext';
import { AppSelectShopContextProvider } from './contexts/AppSelectShopContext';
import { DateContextProvider } from './contexts/DateContext';
import { LoadingContextProvider } from './contexts/LoadingContext';
import { ShopErrorContextProvider } from './contexts/ShopErrorContext';
import ForgotPassword from './views/sessions/ForgotPassword';
import Amplify from 'aws-amplify';

import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

global.API_TYPE = localStorage.getItem('API_TYPE');
console.log('===========================');
console.log('global.API_TYPE', global.API_TYPE);

global.developerId = localStorage.getItem('developerId');
console.log('developerId', global.developerId);
///*
const options = {
  //timeout: 5000,
  position: 'bottom center'
}
//*/



//NOTE:備忘メモ 大きい字を使うときは必ず font-weight:bold 指定すること
const App = () => {

  
  useEffect(() => {
    //console.log('useで呼ばれる',)
    setTimeout(() => {
      document.body.scrollTop = 0
    }, 1000);
    document.body.scrollTop = 0
  })


/*
  Amplify.configure({
    // Amazon Cognito ログイン テスト環境
    // Auth: {
    //   identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    //   region: process.env.REACT_APP_REGION,
    //   userPoolId: process.env.REACT_APP_USER_POOL_ID,
    //   userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    //   oauth: {},
    // },
    // Analytics: { disabled: true },

    // API本番環境(NEW-0928) ////////////////////////////////
    // API: {
    // aws_appsync_graphqlEndpoint: process.env.,
    // aws_appsync_region: "ap-northeast-1",
    // aws_appsync_authenticationType: "API_KEY",
    // aws_appsync_apiKey: process.env.,
    // }

    // APIテスト環境 ////////////////////////////////★SalesView用（APPContorl側の作業のため一旦コメントアウトします 22.10.27
    // API: {
    //  aws_appsync_graphqlEndpoint: process.env.REACT_APP_API,
    //  aws_appsync_region: "ap-northeast-1",
    //  aws_appsync_authenticationType: "API_KEY",
    //  aws_appsync_apiKey: process.env.REACT_APP_API_KEY,
    // }
    API: {//APP Contorol向けのAPI
      aws_appsync_graphqlEndpoint: "https://4vtchgnigzcyni3doeabk4veky.appsync-api.ap-northeast-1.amazonaws.com/graphql",
      aws_appsync_region: "ap-northeast-1",
      aws_appsync_authenticationType: "API_KEY",
      aws_appsync_apiKey: "da2-23ekiri5p5gmdc3jtp7mk4hifa",
    }
  });
  */
  //console.log('process.env.REACT_APP_API:' + process.env.REACT_APP_API)
  //console.log('process.env.REACT_APP_API_KEY:' + process.env.REACT_APP_API_KEY)



  return (
    <AppContext.Provider value={{ routes }}>
      <Provider store={store}>
        <SettingsProvider>
          <AlertProvider template={AlertTemplate}>
            <AppControlContextProvider>
              <LoadingContextProvider>
                <DeveloperUuidContextProvider>
                  <AppShopContextProvider>
                    <AppSelectShopContextProvider>
                      <ShopContextProvider>
                        <ShopErrorContextProvider>
                          <DateContextProvider>
                            <MatxTheme>
                              <GlobalCss />
                              <BrowserRouter>
                                <ScrollToTop>
                                  <Router history={history} onUpdate={() => window.scrollTo(0, 0)}>
                                    <AuthProvider>
                                      <MatxSuspense>

                                        <Switch>
                                          {sessionRoutes.map((item, i) => (
                                            <Route key={i} path={item.path} component={item.component} />
                                          ))}
                                          <Route path="/forgotPassword" component={ForgotPassword} />

                                          {/*<AuthGuard>*/}
                                          {/* <Route path={'/setting/account'} component={NotFound} /> */}
                                          <MatxLayout />
                                          {/*</AuthGuard>*/}
                                        </Switch>
                                      </MatxSuspense>
                                    </AuthProvider>
                                  </Router>
                                </ScrollToTop>
                              </BrowserRouter>
                            </MatxTheme>
                          </DateContextProvider>
                        </ShopErrorContextProvider>
                      </ShopContextProvider>
                    </AppSelectShopContextProvider>
                  </AppShopContextProvider>
                </DeveloperUuidContextProvider>
              </LoadingContextProvider>
            </AppControlContextProvider>
          </AlertProvider>
        </SettingsProvider>
      </Provider>
    </AppContext.Provider>
  );
};

export default App;
